import { jsx as _jsx } from "react/jsx-runtime";
export default function PageNotFound() {
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("h1", {
            className: "text-8xl",
            children: "404"
        })
    });
}
